export default IconCircuitGround => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circuit-ground" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 13v-8" />
  <path d="M4 13h16" />
  <path d="M7 16h10" />
  <path d="M10 19h4" />
</svg>`;